// extracted by mini-css-extract-plugin
export default {"uploadCard":"AdGrid_uploadCard__+jTIr","uploadContent":"AdGrid_uploadContent__qrLsR","uploadIcon":"AdGrid_uploadIcon__BFkwf","uploadText":"AdGrid_uploadText__CXv8H"};